import { ChannelProgramFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformGqlToAgeRestriction } from '@/scenarios/legacy-player/lib/transform-age-restriction';

import { ChannelPlayerProgram } from '../types/channel-player-program';

export const transformTvProgram = <TvChannelProgram extends ChannelProgramFragment>(
    tvProgram: TvChannelProgram
): ChannelPlayerProgram => {
    const {
        startTime: startTimeString,
        endTime: endTimeString,
        ageRestriction,
        ...rest
    } = tvProgram;

    const startTime = new Date(startTimeString);
    const endTime = new Date(endTimeString);

    return {
        startTime,
        endTime,
        ageRestriction: transformGqlToAgeRestriction(ageRestriction),
        duration: endTime.getTime() - startTime.getTime(),
        ...rest,
    };
};
